import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import ShipmentLabelUpload from '@components/shared/orders/ShipmentLabelUpload';
import useSmartBack from '@hooks/shared/useSmartBack';
import PageHeader from '@shared/PageHeader';
import { useTranslation } from 'react-i18next';

import { orderService } from '@services/operator/orderService';
import { fulfillmentService } from '@services/operator/fulfillmentService';

/**
 * Operator 頁面：上傳物流標籤
 * 使用 MerchantSelect 先選擇貨主
 */
export default function OperatorUploadLabels() {
  const { t } = useTranslation();
  const goBack = useSmartBack();

  const handleSuccess = () => {
    goBack();
  };

  const handleCancel = () => {
    goBack();
  };

  return (
    <MerchantSelect>
      <div>
        <PageHeader items={['shipments', 'shipments.upload_labels']} />
        <div style={{ padding: '24px' }}>
          <h1>{t('operator.orders.upload_labels.title')}</h1>
          <ShipmentLabelUpload
            orderService={orderService}
            fulfillmentService={fulfillmentService}
            onSuccess={handleSuccess}
            onCancel={handleCancel}
          />
        </div>
      </div>
    </MerchantSelect>
  );
}
